import React, { Component, useState } from "react";
import { fire, auth } from "../../firebase/index";
import { customLog, timestampToDate } from "../../variables/Variables";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    headerRedemption: "Redemption",
    tableHeaderMax: "Max limit",
    tableHeaderCurrent: "Current",
    titleDetails: "Plan details",
    titlePlan: "Current Plan",
    titleRedemption: "Redemption Method",
    titlePending: "Pending redemption details",
    subheaderPlan: "Add/Manage up to",
    subheaderRedemption: "Current Redemption details",
    endDescription: "Your plan will end on ",
    detailPadlock: "Smart Padlocks",
    detailUsers: "User Accounts",
    detailTags: "NFC Counts",
    detailApproval: "Layer of Multi Approval",
    detailStartedOn: "Started on",
    detailEndingOn: "Ending on",
    startDescription: "Starts on ",
  },
  ja: {
    headerRedemption: "ご契約内容",
    tableHeaderMax: "最大",
    tableHeaderCurrent: "現在",
    titleDetails: "ご契約",
    titlePlan: "ご契約プラン",
    titleRedemption: "ご契約について",
    titlePending: "ご契約内容",
    subheaderPlan: "ご利用可能数量",
    subheaderRedemption: "詳細",
    endDescription: "ご契約期限",
    detailPadlock: "スマートロック台数",
    detailUsers: "メンバー数",
    detailTags: "NFC登録数",
    detailApproval: "承認アカウント数",
    detailStartedOn: "ご契約開始日",
    detailEndingOn: "ご契約終了日",
    startDescription: "開始日 ",
  },
  es: {
    headerRedemption: "Redención",
    tableHeaderMax: "Límite máximo",
    tableHeaderCurrent: "Actual",
    titleDetails: "Detalles del plan",
    titlePlan: "Plan actual",
    titleRedemption: "Método de redención",
    titlePending: "Detalles de redención pendientes",
    subheaderPlan: "Agregar/Gestionar hasta",
    subheaderRedemption: "Detalles de redención actuales",
    endDescription: "Su plan finalizará el ",
    detailPadlock: "Candados inteligentes",
    detailUsers: "Cuentas de usuario",
    detailTags: "Recuento de NFC",
    detailApproval: "Capa de aprobación múltiple",
    detailStartedOn: "Comenzó el",
    detailEndingOn: "Finaliza el",
    startDescription: "Comienza el ",
  },
});

export class RedemptionManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redemptionPlan: "",
      redemptionActiveCode: "",
      redemptionPendingCodeExist: false,
      redemptionPendingList: [],
      pendingRedemptionCode: "",
      redemptionStartedOn: "",
      redemptionEndedOn: "",
      userAccounts: 0,
      userLocks: 0,
    };
  }
  componentWillMount() {
    //! LANAGUE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      //get total amount of accounts under the User.
      fire
        .database()
        .ref("groupAccounts/" + auth.currentUser.uid)
        .child("members")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            let count = 0;
            snapshot.forEach((member) => {
              count++;
            });
            this.setState({
              userAccounts: count,
            });
          }
        });

      //get total amount of locks under the User.
      fire
        .database()
        .ref("userLocks/" + auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            let count = 0;
            snapshot.forEach((lock) => {
              count++;
            });
            this.setState({
              userLocks: count,
            });
          }
        });

      const today = Math.floor(Date.now() / 1000);
      let redemptionPendingList = [];

      fire
        .database()
        .ref("groupAccounts")
        .child(auth.currentUser.uid)
        .child("payment")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            const paymentDetails = snapshot.val();

            for (const i in paymentDetails.redeemedRedemptionCode) {
              if (
                paymentDetails.redeemedRedemptionCode[i].redemptionCode ===
                paymentDetails.currentRedemptionActiveCode
              ) {
                const formattedStartDate = paymentDetails.startedOn * 1000;
                const formattedEndDate =
                  paymentDetails.redeemedRedemptionCode[i].redeemedEndTime *
                  1000;

                let formattedPlan = "";
                if (paymentDetails.plan === 1) {
                  formattedPlan = "Starter";
                } else if (paymentDetails.plan === 2) {
                  formattedPlan = "Essential";
                } else if (paymentDetails.plan === 3) {
                  formattedPlan = "Professional";
                } else if (paymentDetails.plan === 4) {
                  formattedPlan = "Custom";
                } else if (paymentDetails.plan === 5) {
                  formattedPlan = "Starter Plus";
                } else if (paymentDetails.plan === 6) {
                  formattedPlan = "Entry Starter";
                } else if (paymentDetails.plan === 7) {
                  formattedPlan = "Lock Focus";
                } else if (paymentDetails.plan === 8) {
                  formattedPlan = "Pro Lock";
                } else if (paymentDetails.plan === 9) {
                  formattedPlan = "User Focus";
                } else if (paymentDetails.plan === 10) {
                  formattedPlan = "Pro User";
                }

                var redemptionActiveCode =
                  paymentDetails.currentRedemptionActiveCode;
                var formattedRedemptionCode = redemptionActiveCode.substring(
                  0,
                  4
                );

                this.setState({
                  redemptionPlan: formattedPlan,
                  redemptionActiveCode: formattedRedemptionCode,
                  redemptionStartedOn: formattedStartDate,
                  redemptionEndedOn: formattedEndDate,
                });
              } else {
                //!Pending Redemption Code
                var formattedPendingCode = {
                  data: {
                    redemptionCode:
                      paymentDetails.redeemedRedemptionCode[i].redemptionCode,
                    redeemedStartTime:
                      paymentDetails.redeemedRedemptionCode[i]
                        .redeemedStartTime,
                    redeemedEndTime:
                      paymentDetails.redeemedRedemptionCode[i].redeemedEndTime,
                    maxLocks: paymentDetails.redeemedRedemptionCode[i].maxLocks,
                    maxUsers: paymentDetails.redeemedRedemptionCode[i].maxUsers,
                    maxTags: paymentDetails.redeemedRedemptionCode[i].maxTags,
                    maxMulti: paymentDetails.redeemedRedemptionCode[i].maxMulti,
                  },
                };

                redemptionPendingList.push(formattedPendingCode);
                this.setState({
                  redemptionPendingCodeExist: true,
                  redemptionPendingList: redemptionPendingList,
                });
              }
            }

            let formattedEndDate =
              paymentDetails.endedOn != undefined &&
              paymentDetails.endedOn != null
                ? paymentDetails.endedOn * 1000
                : 0;

            this.setState({
              redemptionEndDate: formattedEndDate,
              maxLocks: paymentDetails.maxLocks,
              maxUsers: paymentDetails.maxUsers,
              maxTags: paymentDetails.maxTags,
              maxMulti: paymentDetails.maxMulti,
            });
          }
        });
    }
  }

  getPendingDetails(data) {
    let columnStyle = {
      width: "150px",
    };
    let columnDetailStyle = {
      width: "150px",
    };

    let elements = [];

    data.forEach((item) => {
      let formattedStartDate = this.dateFormat(
        item.data.redeemedStartTime * 1000
      );
      elements.push(
        <div style={{ margin: "0px", marginBottom: "20px", padding: "0px" }}>
          <span
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              fontWeight: "bold",
              fontSize: "18px",
            }}
          >
            {item.data.redemptionCode.substring(0, 4)} - XXXX - XXXX - XXXX
          </span>
          <div style={{ height: "5px" }}></div>
          <span style={{ fontWeight: "bold" }}>
            {localizationStrings.startDescription}
            {`${formattedStartDate}`}
          </span>
          <div style={{ height: "10px" }}></div>
          <table className={"resManagementTable"}>
            <tr>
              <td style={columnStyle} className={"resManagementTD"}>
                {localizationStrings.detailPadlock}
              </td>
              <td style={columnDetailStyle}>{item.data.maxLocks}</td>
            </tr>
            <tr>
              <td style={columnStyle} className={"resManagementTD"}>
                {localizationStrings.detailUsers}
              </td>
              <td style={columnDetailStyle}>{item.data.maxUsers}</td>
            </tr><tr>
              <td style={columnStyle} className={"resManagementTD"}>
                {localizationStrings.detailTags}
              </td>
              <td style={columnDetailStyle}>{item.data.maxTags}</td>
            </tr>
            <tr>
              <td style={columnStyle} className={"resManagementTD"}>
                {localizationStrings.detailApproval}
              </td>
              <td style={columnDetailStyle}>{item.data.maxMulti}</td>
            </tr>
          </table>
          <div
            style={{
              height: "15px",
              width: "150px",
              borderBottom: "1px solid #808080",
            }}
          ></div>
        </div>
      );
    });

    return elements;
  }

  dateFormat(timeStamp) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(timeStamp);
      return japanDate;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      // return <TimeStamp time={time/1000} format="full" includeDay />;
      return timestampToDate(timeStamp / 1000, "DMTY");
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    let columnStyle = {
      width: "150px",
    };
    let columnDetailStyle = {
      width: "50px",
    };
    let columnCardStyle = {
      width: "100px",
    };

    let pendingList = this.state.redemptionPendingList;
    let sortedPendingList = [...pendingList].sort((a, b) =>
      a.data.redeemedEndTime > b.data.redeemedEndTime ? 1 : -1
    );

    return (
      <div>
        <div
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "5px",
            borderBottom: "1px solid #808080",
          }}
        >
          <h4>{localizationStrings.headerRedemption}</h4>
          <br />
          <h5 style={{ marginBottom: "0px", marginTop: "0px" }}>
            {localizationStrings.titlePlan}
          </h5>
        </div>
        <div>
          <div style={{ paddingLeft: "40px" }}>
            {/* <div className={"alignCenter"}> */}
            <br />
            <h3 style={{ marginBottom: "0px", color: "#369AF6" }}>
              eGeeTouch {this.state.redemptionPlan} plan
            </h3>
            <div style={{ height: "10px" }}></div>
            <span style={{ fontWeight: "bold" }}>
              {localizationStrings.endDescription}
              {`${this.dateFormat(this.state.redemptionEndDate)}`}
            </span>
            <br />
            <br />
            <h5 style={{ textDecoration: "underline", marginBottom: "0px" }}>
              {localizationStrings.titleDetails}
            </h5>
            <div style={{ height: "10px" }}></div>
            <span
              style={{
                marginTop: "0px",
                marginBottom: "0px",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              {localizationStrings.subheaderPlan}
            </span>
            <div style={{ height: "10px" }}></div>
            <table className={"resManagementTable"}>
              <tr>
                <th style={columnStyle}></th>
                <th style={columnDetailStyle}>
                  <span
                    style={{ textDecoration: "underline", fontWeight: "bold" }}
                  >
                    {localizationStrings.tableHeaderMax}
                  </span>
                </th>
                {/* <th style={columnDetailStyle}><span style={{ textDecoration: "underline", fontWeight: "bold"  }}>{localizationStrings.tableHeaderCurrent}</span></th> */}
              </tr>
              <tr>
                <td style={columnStyle} className={"resManagementTD"}>
                  {localizationStrings.detailPadlock}
                </td>
                <td style={columnDetailStyle}>{this.state.maxLocks}</td>
                {/* <td style={columnDetailStyle}>{"/ " + this.state.userLocks}</td> */}
              </tr>
              <tr>
                <td style={columnStyle} className={"resManagementTD"}>
                  {localizationStrings.detailUsers}
                </td>
                <td style={columnDetailStyle}>{this.state.maxUsers}</td>
                {/* <td style={columnDetailStyle}>{"/ " + this.state.userAccounts}</td> */}
              </tr><tr>
                <td style={columnStyle} className={"resManagementTD"}>
                  {localizationStrings.detailTags}
                </td>
                <td style={columnDetailStyle}>{this.state.maxTags}</td>
                {/* <td style={columnDetailStyle}>{"/ " + this.state.userAccounts}</td> */}
              </tr>
              <tr>
                <td style={columnStyle} className={"resManagementTD"}>
                  {localizationStrings.detailApproval}
                </td>
                <td style={columnDetailStyle}>{this.state.maxMulti}</td>
              </tr>
            </table>
          </div>
          <br />
          <br />
          <div>
            <div
              style={{
                paddingLeft: "20px",
                paddingRight: "20px",
                paddingBottom: "5px",
                borderBottom: "1px solid #808080",
              }}
            >
              <h5 style={{ fontWeight: "bold", marginBottom: "0px" }}>
                {localizationStrings.titleRedemption}
              </h5>
            </div>
            <div style={{ paddingLeft: "40px" }}>
              <h4 style={{ marginBottom: "15px" }}>
                {localizationStrings.subheaderRedemption}
              </h4>
              <span
                style={{
                  marginTop: "0px",
                  marginBottom: "0px",
                  fontWeight: "bold",
                  fontSize: "18px",
                  color: "#25A422",
                }}
              >
                {this.state.redemptionActiveCode.substring(0, 4)} - XXXX - XXXX
                - XXXX
              </span>
              <div style={{ height: "5px" }}></div>
              <table
                style={{ marginTop: "0px" }}
                className={"resManagementTable"}
              >
                <tr>
                  <td style={columnStyle} className={"resManagementTD"}>
                    {localizationStrings.detailStartedOn}
                  </td>
                  <td style={columnCardStyle}>
                    {this.dateFormat(this.state.redemptionStartedOn)}
                  </td>
                </tr>
                <tr>
                  <td style={columnStyle} className={"resManagementTD"}>
                    {localizationStrings.detailEndingOn}
                  </td>
                  <td style={columnCardStyle}>
                    {this.dateFormat(this.state.redemptionEndedOn)}
                  </td>
                </tr>
              </table>
              <br />
              <br />
              <div
                style={{
                  margin: "0px",
                  padding: "0px",
                  display: this.state.redemptionPendingCodeExist
                    ? "block"
                    : "none",
                }}
              >
                <h5
                  style={{ textDecoration: "underline", marginBottom: "0px" }}
                >
                  {localizationStrings.titlePending}
                </h5>
                <div style={{ height: "15px" }}></div>
                {this.getPendingDetails(sortedPendingList)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RedemptionManagement;
